import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { growthBookInstance } from '../../utils/analytics/growthbook';
import { ABTestAdviseCoverage } from '../../utils/enabled_features/ab_tests';

/** Asks current coverage */
export const CurrentCoverageStep: Step = {
  id: 'currentcoverage',
  pathname: '/currentcoverage',
  canShow: (appData: AppData) => {
    // Don't ask if user did not select insurance service.
    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    const adviseCoverageVariant = growthBookInstance?.getFeatureValue(ABTestAdviseCoverage.storageKey, 0);
    if (adviseCoverageVariant === 1 || adviseCoverageVariant === 2) {
      return true;
    }

    return false;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.signupParams?.currentCoverage,
  category: () => StepCategory.Coverage,
};
